import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const checkboxStyleId = 'wb-v2-checkbox-theme';

export const checkboxBridgeStyles = {
  'wb-checkbox': {
    '--local-checkbox-focus-ring': tokens.focusRing.default,
    '--local-checkbox-box-bg': tokens.color.background.primary,
    '--local-checkbox-box-border': tokens.color.border.primary,
    '--local-checkbox-box-border-hover': tokens.color.border.brand,
    '--local-checkbox-box-bg-on': tokens.color.background.brandSolid,
    '--local-checkbox-box-border-on': tokens.color.background.brandSolid,
    '--local-checkbox-box-bg-disabled': tokens.color.background.disabled,
    '--local-checkbox-box-border-disabled': tokens.color.border.disabled,
    '--local-checkbox-box-radius': tokens.radius.xs,
    '--local-checkbox-check-color': tokens.color.foreground.white,
    '--local-checkbox-check-color-disabled': tokens.color.foreground.disabled,
    '--local-checkbox-box-size': '14px',
    '--local-checkbox-icon-size': '8px',
    '--local-checkbox-label-font-family': tokens.font.family.body,
    '--local-checkbox-label-font-size': tokens.font.size.textXs,
    '--local-checkbox-label-font-weight': tokens.font.weight.medium,
    '--local-checkbox-label-line-height': tokens.lineHeight.textXs,
    '--local-checkbox-label-color': tokens.color.text.secondary,
    '--local-checkbox-description-font-size': tokens.font.size.textXs,
    '--local-checkbox-description-line-height': tokens.lineHeight.textXs,
    '--local-checkbox-description-color': tokens.color.text.tertiary,
    '--local-checkbox-gap': tokens.spacing.sm,
  },
  'wb-checkbox.check-small': {
    '--local-checkbox-box-size': '16px',
    '--local-checkbox-icon-size': '10px',
    '--local-checkbox-label-font-size': tokens.font.size.textSm,
    '--local-checkbox-label-line-height': tokens.lineHeight.textSm,
    '--local-checkbox-description-font-size': tokens.font.size.textSm,
    '--local-checkbox-description-line-height': tokens.lineHeight.textSm,
    '--local-checkbox-gap': tokens.spacing.md,
  },
  'wb-checkbox.check-medium': {
    '--local-checkbox-box-size': '20px',
    '--local-checkbox-icon-size': '12px',
    '--local-checkbox-label-font-size': tokens.font.size.textMdBase,
    '--local-checkbox-label-line-height': tokens.lineHeight.textMd,
    '--local-checkbox-description-font-size': tokens.font.size.textMdBase,
    '--local-checkbox-description-line-height': tokens.lineHeight.textMd,
    '--local-checkbox-gap': tokens.spacing.md,
  },
  'wb-checkbox.check-large': {
    '--local-checkbox-box-size': '24px',
    '--local-checkbox-icon-size': '14px',
    '--local-checkbox-label-font-size': tokens.font.size.textLg,
    '--local-checkbox-label-line-height': tokens.lineHeight.textLg,
    '--local-checkbox-description-font-size': tokens.font.size.textMdBase,
    '--local-checkbox-description-line-height': tokens.lineHeight.textMd,
    '--local-checkbox-gap': tokens.spacing.lg,
  },
};
